module.exports = __webpack_public_path__ + "img/instegram.9da715ae.svg";